import CardHistorico from "../components/Cards/CardHistorico";
import CardMinhaConta from "../components/Cards/CardMinhaConta";
import CardPlano from "../components/Cards/CardPlano";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useNavigate } from "react-router-dom";
import CardTaxaInstalacao from "../components/Cards/CardTaxaInstalacao";
import { motion } from "framer-motion";

function Home() {
  const navigate = useNavigate();

  const propsCardPlanos = {
    descricao: "Planos de Internet",
  };
  const propsCardHistorico = {
    descricao: "Histórico",
  };
  const propsCardConta = {
    descricao: "Minha Conta",
  };
  const propsTaxaInstalacao = {
    descricao: "Primeiro pagamento",
  };

  function enviarParaWhatsapp() {
    const numero = "+258878958450";
    const mensagem = `Olá, tenho uma Avaria`;
    const link = `https://wa.me/${numero}?text=${encodeURIComponent(
      mensagem
    )}`;
    window.open(link, "_blank");
  }

  return (
    <motion.div
      className="flex flex-col min-h-screen justify-between font-questrial text-white"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      {/* Header */}
      <div className="bg-blue-500 h-[240px]">
        <NavBar />
      </div>

      {/* Cards */}
      <div className="flex justify-center gap-2 items-center mt-4 mb-4">
        <motion.div
          className="lg:w-[900px] grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-x-4 -mt-20 lg:-mt-40 md:w-[54%]"
          initial="hidden"
          animate="visible"
          variants={{
            hidden: { opacity: 0 },
            visible: {
              opacity: 1,
              transition: { staggerChildren: 0.15 },
            },
          }}
        >
          {/* Card Planos */}
          <motion.div
            className="w-full mx-auto sm:w-[300px] md:w-[200px] md:h-[200px] lg:w-[180px] lg:h-[200px] sm:flex sm:justify-center"
            variants={{
              hidden: { opacity: 0, y: 30 },
              visible: { opacity: 1, y: 0 },
            }}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <button onClick={() => navigate("/planos")} className="w-full">
              <CardPlano {...propsCardPlanos} />
            </button>
          </motion.div>

          {/* Card Histórico */}
          <motion.div
            className="w-full mx-auto sm:w-[300px] md:w-[200px] md:h-[200px] sm:flex sm:justify-center"
            variants={{
              hidden: { opacity: 0, y: 30 },
              visible: { opacity: 1, y: 0 },
            }}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <button onClick={() => navigate("/recibos")} className="w-full">
              <CardHistorico {...propsCardHistorico} />
            </button>
          </motion.div>

          {/* Card Minha Conta */}
          <motion.div
            className="w-full mx-auto sm:w-[300px] md:w-[200px] md:h-[200px] sm:flex sm:justify-center"
            variants={{
              hidden: { opacity: 0, y: 30 },
              visible: { opacity: 1, y: 0 },
            }}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <button
              onClick={() => navigate("/minhaconta")}
              className="w-full"
            >
              <CardMinhaConta {...propsCardConta} />
            </button>
          </motion.div>

          {/* Card Taxa de Instalação */}
          <motion.div
            className="w-full mx-auto sm:w-[300px] md:w-[200px] md:h-[200px] sm:flex sm:justify-center"
            variants={{
              hidden: { opacity: 0, y: 30 },
              visible: { opacity: 1, y: 0 },
            }}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <button
              onClick={() => navigate("/planos?primeiro=1")}
              className="w-full"
            >
              <CardTaxaInstalacao {...propsTaxaInstalacao} />
            </button>
          </motion.div>
        </motion.div>
      </div>

             {/* WhatsApp */}
<div className="fixed bottom-5 right-5 md:bottom-10 md:right-10 z-50">
  <motion.svg
    onClick={enviarParaWhatsapp}
    className="w-12 h-12 md:w-16 md:h-16 cursor-pointer hover:scale-110 transition-transform"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    animate={{ scale: [1, 1.1, 1] }}
    transition={{ repeat: Infinity, duration: 1.8 }}
  >
    <path
      fill="#63E6BE"
      d="M380.9 97.1C339 55.1 283.2 32 223.9 32
      101.5 32 0 133.5 0 256c0 45 11.9 89.1 34.3 128.1L0 480
      l99.5-26.1C137.7 475.9 180.3 480 223.9 480
      346.4 480 448 378.5 448 256c0-59.3-25.2-115-67.1-157z
      m-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3
      18.6-68.1-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2
      0-101.7 82.8-184.5 184.6-184.5
      49.3 0 95.6 19.2 130.4 54.1
      34.8 34.9 56.2 81.2 56.1 130.5
      0 101.8-84.9 184.6-186.6 184.6z"
    />
  </motion.svg>
</div>
      {/* Footer */}
      <div className="bg-blue-500 p-4 pb-2 font-extralight">
        <Footer />
      </div>
    </motion.div>
  );
}

export default Home;
